document.addEventListener('DOMContentLoaded', function () {
  // options betöltése mindhárom selectbe (az "Egyedi szöveg" után)
  var tpl = document.getElementById('single-inspo-options');
  if (tpl && tpl.content) {
    var optionsHTML = tpl.innerHTML;
    document.querySelectorAll('.single-pick').forEach(function(sel){
      sel.insertAdjacentHTML('beforeend', optionsHTML);
    });
  }

  function setMode(fieldEl, mode, value) {
    var chosen = fieldEl.querySelector('.single-chosen');
    var input  = fieldEl.querySelector('.single-value');

    if (mode === 'custom') {
      chosen.style.display = 'none';
      chosen.textContent = '';
      input.style.display = 'block';
      if (!input.value) input.value = '';
      input.focus();
      return;
    }

    if (mode === 'preset') {
      input.style.display = 'none';
      chosen.style.display = 'block';
      chosen.textContent = value;
      // kosárhoz / mentéshez ide is beírjuk
      input.value = value;
      return;
    }

    // none
    chosen.style.display = 'none';
    chosen.textContent = '';
    input.style.display = 'none';
    input.value = '';
  }

  document.querySelectorAll('.single-field').forEach(function(field){
    var sel = field.querySelector('.single-pick');
    if (!sel) return;

    setMode(field, 'none', '');

    sel.addEventListener('change', function(){
      if (!sel.value) return setMode(field, 'none', '');
      if (sel.value === '__custom__') return setMode(field, 'custom', '');
      return setMode(field, 'preset', sel.value);
    });
  });
});
